import axios from "axios";
import {
  CreateServiceRequest,
  CreateServiceData,
  GetServicesParams,
  GetServicesResponse,
  PaypalUserAuthRequest,
  CreateSubscriptionRequest,
  CancelSubscriptionRequest,
  CreateSubscriptionData,
  CancelSubscriptionData,
  InitiateIndividualChatResponse,
  GetServiceSlotsDetailsData,
  PurchaseServiceSlotsRequest,
  PurchaseServiceSlotsData,
  GetSubscriptionDetailsData,
  GetServicesByStatusRequest,
  GetServicesByStatusResponse,
  GetChatByIdResponse,
  InitiateIndividualChatParams,
  DoesIndividualChatExistParams,
  DoesIndividualChatExistResponse,
  UpdateUserAuthProfileQuery,
  UpdateUserAuthProfileParams,
  UpdateUserAuthProfileData,
  GetServicesByCatServicesResponse,
  UserVerifyPasswordParams,
  UserVerifyPasswordData,
  ServicesImpressionsInsightParams,
  ServicesImpressionsInsightData,
  ServicesViewInsightData,
  ServicesPurchasesInsightData,
  ServicesConversionInsightData,
  ClientsByLocationInsightData,
  ClientsByIndustryInsightData,
  ClientsNewAndRecurringInsightData,
  ClientsActivityHoursInsightData,
  GetCustomCategoryListServiceParams,
  GetCustomCategoryListServiceData,
  GetServicesByCatServicesParams,
  CaptureServicesImpressionParams,
  ServicesViewInsightParams,
  ServicesPurchasesInsightParams,
  ServicesConversionInsightParams,
  ClientsByLocationInsightParams,
  ClientsByIndustryInsightParams,
  ClientsNewAndRecurringInsightParams,
  ClientsActivityHoursInsightParams,
  GetServiceSlotsProductData,
  GetUserChatsParams,
  GetDisputeListServiceParams,
  GetDisputeListServiceData,
  AddDisputeServiceParams,
} from "./types/api";

import { ApiInstance, ResponseBaseType } from "./axios-instance";
import { CategoryServiceData } from "./types/api/getCategoryService";

export const adminLoginService = (params: any): ResponseBaseType<any> =>
  ApiInstance.post("/api/v1/admin/login", params);

export const adminLogOutService = (params: any) => ApiInstance.post("/api/v1/admin/logout", params);

export const adminForgotPasswordService = (params: any) =>
  ApiInstance.post("/api/v1/admin/forget-password", params);

export const adminResetPasswordService = (params: any, token: any) => {
  axios.defaults.headers.common["accessToken"] = `${token}`;
  // axios.defaults.headers.common["authorization"] = `${settings.api.AUTH}`;
  return axios.post("/api/v1/admin/reset-password", params);
};

export const adminChangePasswordService = (params: any, token: any) => {
  axios.defaults.headers.common["accessToken"] = `${token}`;
  // axios.defaults.headers.common["authorization"] = `${settings.api.AUTH}`;
  return axios.put("/api/v1/admin/change-password", params);
};

export const tokenVarificationService = (params: any) =>
  ApiInstance.get(`${"/api/v1/admin/verify-token"}?token=${params}`);

export const createAdminService = (params: any) => ApiInstance.post("/api/v1/admin/create", params);

export const getAdminService = (params: any) => ApiInstance.get(`${"/api/v1/admin/get"}/${params}`);

export const deleteAdminService = (params: any) => ApiInstance.put("/api/v1/admin/delete", params);

export const updateAdminService = (params: any) => ApiInstance.put("/api/v1/admin/update", params);

export const getCmsService = () => ApiInstance.get("/api/v1/cms/get");

export const addCmsService = (params: any) => ApiInstance.post("/api/v1/cms/add", params);

export const updateCmsService = (params: any) => ApiInstance.put("/api/v1/cms/update", params);

export const multiDeleteService = (params: any) =>
  ApiInstance.post("/api/v1/admin/action/multi-delete", params);

export const getDashboardDetails = () => ApiInstance.get("/api/v1/dashboard/dashboard");

export const addFAQs = (params: any) => ApiInstance.post("/api/v1/faq/admin/create-faq", params);

export const getFAQs = (params: any) =>
  ApiInstance.get(
    `${"/api/v1/faq/admin/faq-list"}?page=${params.page}&limit=${params.limit}&type=${params.type}&searchString=${params.searchString}`,
  );

export const updateFAQs = (params: any) =>
  ApiInstance.put(`${"/api/v1/faq/admin/faq-update"}?faqId=${params.faqId}`, params);

export const deleteFAQs = (params: any) => ApiInstance.post("/api/v1/faq/admin/delete-faq", params);

export const getDetailFAQs = (params: any) =>
  ApiInstance.get(`${"/api/v1/faq//admin/get-faq"}?faqId=${params}`);

export const userExistService = (params: any): ResponseBaseType<any> =>
  ApiInstance.post(`/api/v1/user/exist`, params);

export const accountStatusService = (params: any) => ApiInstance.put("/api/v1/admin/block/user", params);

export const userLogoutService = (token: any) => {
  ApiInstance.defaults.headers.common["accessToken"] = `${token}`;
  // axios.defaults.headers.common["authorization"] = `${process.env.REQUEST_AUTH}`;
  return ApiInstance.post(`/api/v1/user/logout`);
};

export const updateUserAuthProfile = (
  query: UpdateUserAuthProfileQuery,
  params: UpdateUserAuthProfileParams,
): ResponseBaseType<UpdateUserAuthProfileData> =>
  ApiInstance.post(`/api/v1/user/update/auth/profile/${query}`, params);

export const veryfyTokenService = (params: any): ResponseBaseType<any> =>
  ApiInstance.get(`/api/v1/user/verify-token?token=${params}`);

export const userResendEmailService = (params: any): ResponseBaseType<any> =>
  ApiInstance.post(`/api/v1/user/verify/email`, params);

export const changeEmailService = (params: any): ResponseBaseType<any> =>
  ApiInstance.put(`/api/v1/user/change-email`, params);

export const userForgotPasswordService = (params: any): ResponseBaseType<any> =>
  ApiInstance.post(`/api/v1/user/forget-password`, params);

export const userVerifyPassword = (
  params: UserVerifyPasswordParams,
): ResponseBaseType<UserVerifyPasswordData> => ApiInstance.post(`/api/v1/user/validatePassword`, params);

export const updateUserPassword = (params: any): ResponseBaseType<any> =>
  ApiInstance.post(`/api/v1/user/update/password`, params);

export const emailVerifyService = (token: any) => {
  ApiInstance.defaults.headers.common["accessToken"] = `${token}`;
  // axios.defaults.headers.common["authorization"] = `${process.env.REQUEST_AUTH}`;
  return ApiInstance.put(`/api/v1/user/verify/email`);
};

export const userResetPasswordService = (params: any, token: any) => {
  axios.defaults.headers.common["accessToken"] = `${token}`;
  // axios.defaults.headers.common["authorization"] = `${process.env.REQUEST_AUTH}`;
  return axios.post(`/api/v1/user/reset-password`, params);
};

/** @deprecated Needs replacement in BE */
export const signUpUserUsingSocials = (params: any): ResponseBaseType<any> =>
  ApiInstance.post(`/api/v1/user/social-signup`, params);

/** @deprecated Needs replacement in BE */
export const userSocialLoginService = (params: any): ResponseBaseType<any> =>
  ApiInstance.post(`/api/v1/user/social-login`, params);

/** @deprecated Needs replacement in BE */
export const isPhoneExistService = (params: any): ResponseBaseType<any> =>
  ApiInstance.get(`/api/v1/user/isContactExists${params}`);

export const appleRedirectService = (params: any): ResponseBaseType<any> =>
  ApiInstance.post(`/api/v1/common/apple-redirect`, params);

export const fileUploadService = (params: any, options?: any): ResponseBaseType<any> =>
  ApiInstance.post(`/api/v1/common/singleFile`, params, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    ...options,
  });

export const multiFileUploadWithLoaderService = (params: any, options: any): ResponseBaseType<any> =>
  ApiInstance.post(`/api/v1/common/multipleFile`, params, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    ...options,
  });

export const userVerifyDocumentService = (params: any) =>
  ApiInstance.put("/api/v1/user/verify-document", params);

export const getUserCategoryService = (params: any) =>
  ApiInstance.get(`/api/v1/category?categoryId=${params}`);

export const getAllCategoriesService = (params: any): ResponseBaseType<any> =>
  ApiInstance.get(
    `${"/api/v1/category/get-all-categories"}?type=${params.type}&page=${params.page}&limit=${params.limit}`,
  );

/** @deprecated Use `v2/categories/get-categories` */
export const getCategoryService = (params: any): ResponseBaseType<CategoryServiceData> =>
  ApiInstance.get(`/api/v1/category/get-category-list`, { params });

/** @deprecated Use `v2/categories/get-categories` */
export const getCustomCategoryListService = (
  params: GetCustomCategoryListServiceParams,
): ResponseBaseType<GetCustomCategoryListServiceData> =>
  ApiInstance.get(`/api/v1/category/custom-category-list`, { params });

/** @deprecated Use `v2/categories/get-subcategories` */
export const getSubCategoryService = (params: any): ResponseBaseType<any> =>
  ApiInstance.get(`/api/v1/category/get-subcategory-list${params}`);

/** @deprecated Use `v2/categories/get-subcategory-skills` */
export const getSkillsService = (params: any): ResponseBaseType<any> =>
  ApiInstance.get(`/api/v1/category/get-skills${params}`);

export const deleteCategoryService = (params: any) =>
  ApiInstance.delete(`${"/api/v1/category/update"}?categoryId=${params}`);

export const deleteAllService = (params: any) =>
  ApiInstance.post("/api/v1/admin/action/multi-delete", params);

export const updateCategoryService = (params: any) => ApiInstance.put("/api/v1/category/update", params);

export const addCategoryService = (params: any) => ApiInstance.post("/api/v1/category/add", params);

export const getAllServicesList = (params: any): ResponseBaseType<any> =>
  ApiInstance.get(
    `/api/v1/admin/service-list?page=${params.page}&limit=${params.limit}&searchString=${params.searchString}&status=${params.status}&category=${params.category}&subCategory=${params.subCategory}&talentId=${params.talentId}`,
  );

export const getUsersByRoleService = (params: any): ResponseBaseType<any> =>
  ApiInstance.get(
    `/api/v1/user/userlist-by-role?role=${params?.role}&page=${params?.page}&limit=${params?.limit}&status=${params?.status}&searchString=${params?.searchString}&blocked=${params?.blocked}`,
  );

export const createService = (params: CreateServiceRequest): ResponseBaseType<CreateServiceData> =>
  ApiInstance.post(`/api/v1/user/add/service`, params);

export const getServices = (params?: GetServicesParams): ResponseBaseType<GetServicesResponse> =>
  ApiInstance.get(`/api/v1/user/get/service-by-userId`, { params });

export const getPublicServices = (
  params: Omit<GetServicesParams, "profileOnly"> & { userId: string },
): ResponseBaseType<GetServicesResponse> =>
  ApiInstance.get(`/api/v1/user/get/public/service-by-userId`, { params });

export const getServicesByStatus = (
  params: GetServicesByStatusRequest,
): ResponseBaseType<GetServicesByStatusResponse> =>
  ApiInstance.get(`/api/v1/user/get/service-by-status`, { params });

export const getServiceDetailService = (params: any): ResponseBaseType<any> =>
  ApiInstance.get(`/api/v1/user/get/service${params}`);

export const getServiceDetailsPublic = (params: any): ResponseBaseType<any> =>
  ApiInstance.get(`/api/v1/user/public/get/service${params}`);

export const deleteServiceService = (params: any): ResponseBaseType<any> =>
  ApiInstance.delete(`/api/v1/user/delete/service${params}`);

export const getChatMessages = (params: any): ResponseBaseType<any> =>
  ApiInstance.get(`/api/v1/message/get/` + params);

export const doesIndividualChatExist = (
  params: DoesIndividualChatExistParams,
): ResponseBaseType<DoesIndividualChatExistResponse> =>
  ApiInstance.put(`/api/v1/chat/individual/exist/`, params);

export const initiateIndividualChat = (
  params: InitiateIndividualChatParams,
): ResponseBaseType<InitiateIndividualChatResponse> =>
  ApiInstance.post(`/api/v1/chat/individual/initiate`, params);

export const getUserChats = (params: GetUserChatsParams): ResponseBaseType<any> =>
  ApiInstance.get(`/api/v1/chat/user`, { params });

export const getChatById = (params: string): ResponseBaseType<GetChatByIdResponse> =>
  ApiInstance.get(`/api/v1/chat/chat-by-id/${params}`);

export const getPortfolioList = (params: any): ResponseBaseType<any> =>
  ApiInstance.get(`/api/v1/user/get/portfolio-by-userId${params}`);

export const getPortfolioDraftList = (params: any): ResponseBaseType<any> =>
  ApiInstance.get(`/api/v1/user/get/draft-portfolio${params}`);

export const createPortFolioService = (params: any): ResponseBaseType<any> =>
  ApiInstance.post(`/api/v1/user/add/portfolio`, params);

export const editPortFolioService = (params: any): ResponseBaseType<any> =>
  ApiInstance.put(`/api/v1/user/update/portfolio`, params);

export const deletePortFolioService = (params: any): ResponseBaseType<any> =>
  ApiInstance.delete(`/api/v1/user/delete/portfolio${params}`);

export const deleteChat = (params: any): ResponseBaseType<any> =>
  ApiInstance.delete(`/api/v1/chat/${params}`);

export const getPortfolioDetailsList = (params: any): ResponseBaseType<any> =>
  ApiInstance.get(`/api/v1/user/get/portfolio${params}`);

export const updateChatStatus = (params: any): ResponseBaseType<any> =>
  ApiInstance.put(`/api/v1/chat/status`, params);

export const readMessage = (params: any): ResponseBaseType<any> =>
  ApiInstance.post(`/api/v1/message/read`, params);

export const unreadMessage = (params: any): ResponseBaseType<any> =>
  ApiInstance.put(`/api/v1/message/unread`, params);

export const deleteChatStatus = (params: any): ResponseBaseType<any> =>
  ApiInstance.put(`/api/v1/chat/status/remove`, params);

export const uploadFileAndGetThumbnail = (params: any): ResponseBaseType<any> =>
  ApiInstance.post(`/api/v1/common/file/thumbnail`, params, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const getDisputeListService = (
  params: GetDisputeListServiceParams,
): ResponseBaseType<GetDisputeListServiceData> =>
  ApiInstance.get(`/api/v1/dispute/get/dispute-by-userId`, { params });

export const addDisputeService = (params: AddDisputeServiceParams): ResponseBaseType<any> =>
  ApiInstance.post(`/api/v1/dispute/add/`, params);

export const getDisputeByIdService = (params: any): ResponseBaseType<any> =>
  ApiInstance.get(`/api/v1/dispute/get` + params);

export const closeDisputeService = (params: any): ResponseBaseType<any> =>
  ApiInstance.put(`/api/v1/dispute/close`, params);

export const reOpenDisputeService = (params: any): ResponseBaseType<any> =>
  ApiInstance.put(`/api/v1/dispute/reopen`, params);

export const editDisputeService = (params: any): ResponseBaseType<any> =>
  ApiInstance.put(`/api/v1/dispute/update`, params);

export const updateDisputeService = (params: any) =>
  ApiInstance.put(`${"/api/v1/dispute/change"}/${params.status}`, params.data);

export const getDisputeByServiceProgressId = (params: any): ResponseBaseType<any> =>
  ApiInstance.get(`/api/v1/dispute/get-dispute-by-serviceProgressId`, { params });

export const getSaveCardListService = (): ResponseBaseType<any> =>
  ApiInstance.get(`/api/v1/stripe/card-list-cognifle`);

export const paypalUserAuthService = (params: PaypalUserAuthRequest): ResponseBaseType<any> =>
  ApiInstance.get(`/api/v1/payment/paypal-user-auth`, { params });

export const contactPageService = (params: any): ResponseBaseType<any> =>
  ApiInstance.post(`/api/v1/support/user/add-query`, params);

export const getPaypalAccountService = (): ResponseBaseType<any> =>
  ApiInstance.get(`/api/v1/payment/get/paypal`);

export const createPaidRequestService = (params: any): ResponseBaseType<any> =>
  ApiInstance.post(`/api/v1/paid/add-request`, params);

export const getPaymentRequestList = (params: any) =>
  ApiInstance.get(
    `${"/api/v1/paid/request-list"}?&status=${params.status}&page=${params.page}&limit=${params.limit}&requestId=${params.searchString}&userId=${params.talentId}`,
  );
export const getPaymentRequestDetails = (params: any) =>
  ApiInstance.get(`${"/api/v1/paid/get-request"}?requestId=${params}`);

export const rejectPaymentRequest = (params: any) => ApiInstance.put("/api/v1/paid/reject-request", params);

export const getServiceChargeAll = (params: any) =>
  ApiInstance.get(
    `${"/api/v1/service-charge/list"}?&status=${params.type}&page=${params.page}&limit=${params.limit}&searchString=${params.searchString}`,
  );
export const addServiceCharge = (params: any) => ApiInstance.post("/api/v1/service-charge/add", params);
export const getServiceChargeDetails = (params: any) =>
  ApiInstance.get(`${"/api/v1/service-charge/admin-view"}?Id=${params}`);
export const updateServiceCharge = (params: any) => ApiInstance.put("/api/v1/service-charge/update", params);
export const deleteServiceCharge = (params: any) =>
  ApiInstance.delete(`${"/api/v1/service-charge/delete"}?Id=${params}`);

export const getNotificationsService = (params: any): ResponseBaseType<any> =>
  ApiInstance.get(`/api/v1/notification/user` + params);

export const getServiceChargeService = (params: any): ResponseBaseType<any> =>
  ApiInstance.get(`/api/v1/service-charge/get`, { params });

export const getAdvertiseMentList = (params: any): ResponseBaseType<any> =>
  ApiInstance.get(`/api/v1/ads/user/adsList${params}`);

export const addAds = (params: any) => ApiInstance.post("/api/v1/ads/admin/add-ads", params);
export const getAllAds = (params: any) =>
  ApiInstance.get(
    `${"/api/v1/ads/admin/adsList"}?page=${params.page}&limit=${params.limit}&title=${params.searchString}&status=${params.status}&type=${params.type}&state=${params.state}`,
  );
export const deleteSingleAds = (params: any) => ApiInstance.post("/api/v1/ads/admin/deleteAds", params);
export const updateAdsDetails = (params: any) =>
  ApiInstance.put(
    `${"/api/v1/ads/admin/updateAds"}?adsId=${params.adsId}&status=${params.status}&title=${params.title}&link=${params.link}&image=${params.image}&description=${params.description}`,
  );

export const getAdsDetails = (params: any) => ApiInstance.get(`/api/v1/ads/admin/getAds?adsId=${params}`);

export const sendOTPCode = (params: any): ResponseBaseType<any> =>
  ApiInstance.post(`/api/v1/otp/send-otp`, params);

export const verifyOTPCode = (params: any): ResponseBaseType<any> =>
  ApiInstance.post(`/api/v1/otp/verify-otp`, params);

export const getServicesByCatServices = (
  params: GetServicesByCatServicesParams,
): ResponseBaseType<GetServicesByCatServicesResponse> =>
  ApiInstance.post(`/api/v1/user/custom/service/list`, params);

export const getPortfolioDetails = (params: any) =>
  ApiInstance.get(`${"/api/v1/user/get/portfolio"}?portfolioId=${params}`);
export const getPortfolio = (params: any) =>
  ApiInstance.get(
    `${"/api/v1/admin/portfolio-list"}?status=${params.status}&page=${params.page}&limit=${params.limit}&searchString=${params.searchString}&categoryId=${params.category}`,
  );
export const updatePortfolioStatus = (params: any) =>
  ApiInstance.post(`${"/api/v1/admin/change/portfolio"}/${params.status}`, params);

export const getHomepageCategories = () => ApiInstance.get(`/api/v2/homepage/get-categories`);

export const addHomepageProfessional = (params: any): ResponseBaseType<any> =>
  ApiInstance.post("/api/v2/homepage/add-professional", params);

export const removeHomepageProfessional = (params: any): ResponseBaseType<any> =>
  ApiInstance.post("/api/v2/homepage/remove-professional", params);

export const getHomepageProfessionals = (): ResponseBaseType<any> =>
  ApiInstance.get(`/api/v2/homepage/get-professionals`);

export const showContactUs = (params: any) =>
  ApiInstance.get(
    `${"/api/v1/support/admin/get-queries"}?status=${params.status}&type=${params.type}&page=${params.page}&limit=${params.limit}&searchString=${params.searchString}`,
  );
export const replyContactUs = (params: any) =>
  ApiInstance.put("/api/v1/support/admin/respondOnQuery", params);
export const viewContactDetails = (params: any) =>
  ApiInstance.get(`${"/api/v1/support/admin/getQueryById"}?queryId=${params}`);

export const serviceReportServices = (params: any): ResponseBaseType<any> =>
  ApiInstance.put(`/api/v1/user/report/service`, params);

export const servicesPreFilterServices = (params: any): ResponseBaseType<any> =>
  ApiInstance.get(`/api/v1/user/get/service/filter${params}`);

export const getPopularSkillsList = (params: any): ResponseBaseType<any> =>
  ApiInstance.get(`/api/v1/category/get-top-skills${params}`);

export const updateServicesStatus = (params: any) =>
  ApiInstance.post(`"/api/v1/admin/change/services"}/${params.status}`, params);

export const getClientReview = (params: any) =>
  ApiInstance.get(
    `${"/api/v1/review/getReviewList"}?page=${params.page}&limit=${params.limit}&searchString=${params.searchString}&status=${params.status}&type=${params.type}&rating=${params.rating}&sort=${params.sort}`,
  );

export const updateClientReviewStatus = (params: any) =>
  ApiInstance.put(`${"/api/v1/review/statusChange"}?reviewId=${params.reviewId}&status=${params.status}`);

export const deleteClientReview = (params: any) =>
  ApiInstance.post(`${"/api/v1/review/admin/delete-review"}`, params);

export const deleteReply = (params: any) =>
  ApiInstance.delete(`${"/api/v1/review/deleteReply"}?replyId=${params.replyId}&reviewId=${params.reviewId}`);

export const getClientReviewDetails = (params: any) =>
  ApiInstance.get(`${"/api/v1/review/admin/getReviewByUserId"}?userId=${params.id}&rating=${params.rating}`);

export const getClientReviewDetailsbyId = (params: any) =>
  ApiInstance.get(`${"/api/v1/review/getReviewByReviewId"}?reviewId=${params}`);

export const getTopTalentListAll = (params: any) =>
  ApiInstance.get(
    `${"/api/v1/review/get-talent-list"}?page=${params.page}&limit=${params.limit}&searchString=${params.searchString}&project=${params.sort}&rating=${params.rating}&status=${params.status}&categoryId=${params.category}&subCategoryId=${params.subCategory}&skillId=${params.skills}&month=${params.month}&year=${params.year}`,
  );
export const statusTopTalentChange = (params: any) =>
  ApiInstance.put(
    `${"/api/v1/review/talentStaus-update"}?id=${params.id}&status=${params.status}&month=${params.month}&year=${params.year}`,
  );
export const getTopTalentDetails = (params: any) =>
  ApiInstance.get(`${"/api/v1/review/admin/view-talent"}?userId=${params}`);

export const getFaqList = (params: any): ResponseBaseType<any> =>
  ApiInstance.get(`/api/v1/faq/user/faq-list${params}`);

export const getAllSkillsList = (): ResponseBaseType<any> =>
  ApiInstance.get(`/api/v1/category/get-all-skills`);

export const getViewingStatusService = (): ResponseBaseType<any> =>
  ApiInstance.get(`/api/v1/notification/has/seen`);

export const createCustomerCognifle = (params: any): ResponseBaseType<any> =>
  ApiInstance.post(`/api/v1/stripe/create-customer-cognifle`, params);

export const createSubscriptionCognifle = (
  params: CreateSubscriptionRequest,
): ResponseBaseType<CreateSubscriptionData> =>
  ApiInstance.post(`/api/v2/subscriptions/create-subscription`, params);

export const updateSubscriptionCognifle = (
  params: CreateSubscriptionRequest,
): ResponseBaseType<CreateSubscriptionData> =>
  ApiInstance.post(`/api/v2/subscriptions/update-subscription`, params);

export const cancelSubscriptionCognifle = (
  params: CancelSubscriptionRequest,
): ResponseBaseType<CancelSubscriptionData> =>
  ApiInstance.post(`/api/v2/subscriptions/cancel-subscription`, params);

export const getSubscriptionDetails = (): ResponseBaseType<GetSubscriptionDetailsData> => {
  return ApiInstance.get(`/api/v2/subscriptions/get-subscription-details`);
};

export const getServiceSlotsDetails = (): ResponseBaseType<GetServiceSlotsDetailsData> =>
  ApiInstance.get(`/api/v2/subscriptions/get-service-slots-details`);

export const getServiceSlotsProducts = (): ResponseBaseType<GetServiceSlotsProductData> =>
  ApiInstance.get(`/api/v2/subscriptions/get-service-slots-products`);

export const purchaseServiceSlots = (
  params: PurchaseServiceSlotsRequest,
): ResponseBaseType<PurchaseServiceSlotsData> =>
  ApiInstance.post(`/api/v2/subscriptions/purchase-service-slots-product`, params);

export const addCardCognifle = (params: any): ResponseBaseType<any> =>
  ApiInstance.post(`/api/v1/stripe/add-card-cognifle`, params);

export const retrieveCardCognifle = (): ResponseBaseType<any> =>
  ApiInstance.get(`/api/v1/stripe/card-list-cognifle`);

export const removeCardCognifle = (params: any): ResponseBaseType<any> =>
  ApiInstance.post(`/api/v1/stripe/remove-card-cognifle`, params);

export const listFreePikImages = (params: any): ResponseBaseType<any> =>
  ApiInstance.get(`/api/v2/freepik/list-images`, { params });

export const captureServicesImpression = (params: CaptureServicesImpressionParams): ResponseBaseType<any> =>
  ApiInstance.post(`/api/v2/analytics/capture/services-impression`, params);

export const servicesImpressionsInsight = (
  params: ServicesImpressionsInsightParams,
): ResponseBaseType<ServicesImpressionsInsightData> =>
  ApiInstance.get(`/api/v2/analytics/subscribers/services-impressions`, { params });

export const servicesViewsInsight = (
  params: ServicesViewInsightParams,
): ResponseBaseType<ServicesViewInsightData> =>
  ApiInstance.get(`/api/v2/analytics/subscribers/services-views`, { params });

export const servicesPurchasesInsight = (
  params: ServicesPurchasesInsightParams,
): ResponseBaseType<ServicesPurchasesInsightData> =>
  ApiInstance.get(`/api/v2/analytics/subscribers/services-purchases`, { params });

export const servicesConversionInsight = (
  params: ServicesConversionInsightParams,
): ResponseBaseType<ServicesConversionInsightData> =>
  ApiInstance.get(`/api/v2/analytics/subscribers/services-conversion`, { params });

export const clientsByLocationInsight = (
  params: ClientsByLocationInsightParams,
): ResponseBaseType<ClientsByLocationInsightData> =>
  ApiInstance.get(`/api/v2/analytics/subscribers/clients-by-location`, { params });

export const clientsByIndustryInsight = (
  params: ClientsByIndustryInsightParams,
): ResponseBaseType<ClientsByIndustryInsightData> =>
  ApiInstance.get(`/api/v2/analytics/subscribers/clients-by-industry`, { params });

export const clientNewAndRecurringInsight = (
  params: ClientsNewAndRecurringInsightParams,
): ResponseBaseType<ClientsNewAndRecurringInsightData> =>
  ApiInstance.get(`/api/v2/analytics/subscribers/clients-new-and-recurring`, {
    params,
  });

export const clientActivityHoursInsight = (
  params: ClientsActivityHoursInsightParams,
): ResponseBaseType<ClientsActivityHoursInsightData> =>
  ApiInstance.get(`/api/v2/analytics/subscribers/client-activity-hours`, {
    params,
  });

export const getEmailLists = () => ApiInstance.get("/api/v2/email-list/get-all-email-lists");
export const getEmailsFromList = (id: any, params: any) =>
  ApiInstance.get("/api/v2/email-list/get-email-list", { params: { ...params, listId: id } });
export const editEmailListItem = (params: any) =>
  ApiInstance.post("/api/v2/email-list/edit-email-item", params);
export const approveUserOnWaitlist = (params: any) =>
  ApiInstance.post("/api/v2/email-list/approve-user-on-waitlist", params);

export const getFreePikPlanInfo = (): ResponseBaseType<any> =>
  ApiInstance.get("/api/v2/freepik/freepik-plan-info");
